import img1 from "../images/post/style-1.png";
import img2 from "../images/post/style-2.png";
import img3 from "../images/post/style-3.png";

const dataBlog = [
  {
    id: 1,
    img: img1,
    category: "digitalart",
    title: "Cyberpunk Work Art",
    time: "20 Jun 2022",
    text: "A sci-fi genre about human society in a hypothetical near future where technology is at its peak",
  },
  {
    id: 2,
    img: img2,
    category: "nftartwork",
    title: "Digital Artwork",
    time: "20 Jun 2022",
    text: "A broad and loosely defined art genre not restricted to a specific school of artists, geographical location or historical period",
  },
  {
    id: 3,
    img: img3,
    category: "digitalart",
    title: "Fantastical Artwork",
    time: "20 Jun 2022",
    text: "Works of art that use digital technology as an integral part of the process of composing",
  },
];

export default dataBlog;
